import { render } from "./DashboardMetrics.vue?vue&type=template&id=7cbd05dc"
import script from "./DashboardMetrics.vue?vue&type=script&lang=js"
export * from "./DashboardMetrics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__